import {
  getExpenseCategoriesData,
  searchExpenseCategoriesData,
} from "@/Api/expenseCategories";
import { AddExpenseCategoryBtn } from "@/App/ExpenseCategories/Add";
import { TableData } from "@/App/ExpenseCategories/Table";
import { SearchComponent } from "@/App/Tenants/Search";
import { If } from "@/components/If";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { usePermissions } from "@/hooks/usePermissions";
import { TypePageActions } from "@/pages/Plans";
import { ApiDataProps } from "@/pages/Tenants";
import { ExpenseCategoryProps } from "@/types/expenseCategory";
import { useEffect, useState } from "react";

export const ExpenseCategoriesPage = () => {
  const [categoriesData, setCategoriesData] = useState(
    {} as ApiDataProps<ExpenseCategoryProps>
  );
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();
  useEffect(() => {
    (async () => {
      const { data } = await getExpenseCategoriesData();
      setCategoriesData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (categoriesData?.current_page < categoriesData?.last_page) {
        setState("loading");

        const { data } = await getExpenseCategoriesData(
          categoriesData?.current_page + 1
        );
        setCategoriesData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (categoriesData?.current_page > 1) {
        setState("loading");

        const { data } = await getExpenseCategoriesData(
          categoriesData?.current_page - 1
        );
        setCategoriesData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (categoriesData?.current_page !== categoriesData?.last_page) {
        setState("loading");

        const { data } = await getExpenseCategoriesData(
          categoriesData?.last_page
        );
        setCategoriesData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-income-categories-list")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            Categorias de Despesas
          </h2>
          <If condition={hasPermission("create-income-category")}>
            <AddExpenseCategoryBtn
              updateFront={setCategoriesData}
              dataApi={categoriesData}
            />
          </If>
        </div>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setCategoriesData}
            setState={setState}
            funcSearch={searchExpenseCategoriesData}
            placeholder="Pesquisar categorias de despesas"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={5} lines={6} />
          ) : (
            <TableData
              updateFront={setCategoriesData}
              dataApi={categoriesData}
              pageActions={pageActions}
            />
          )}
        </div>
      </If>
    </Main>
  );
};

export const PageList = () => {
  return <ExpenseCategoriesPage />;
};
